// import contactImg from "../../assets/images/fillers/contactImg.png"
const Contact = () => {
    return (
      <section className=" py-16 px-4 sm:px-8 md:px-16 min-h-screen h-screen  bg-white">

        <div className="contact flex flex-row w-full h-full gap-2 justify-between items-center">
          <div className="  contactImg  md:w-2/5 h-full rounded-xl md:block hidden ">
          </div>
          <div className="contactform w-full md:w-3/5 px-8 py-16 lg:px-12 items-center justify-center flex flex-col rounded-xl h-full bg-[#314898]/10 backdrop-blur-xl">
          <h2 className="text-3xl font-bold text-gray-800 mb-3 text-left  w-full">Contact Us</h2>
          <h2 className="text-md font-thin text-gray-500 mb-6 text-left w-full font-merriweather">Reach out and we will get in touch with you!</h2>
          <form className="  py-6 rounded-lg  w-full">
            <input type="text" placeholder="Your Name" className="w-full p-3 border rounded-lg mb-4 focus:outline-blue-500" />
            <input type="email" placeholder="Your Email" className="w-full p-3 border rounded-lg mb-4 focus:outline-blue-500" />
            <textarea placeholder="Your Message" className="w-full p-3 border rounded-lg mb-4 h-32 focus:outline-blue-500"></textarea>
            <button className="w-full bg-[#314898] text-white p-3 rounded-lg font-semibold hover:bg-[#24346d] transition font-merriweather">Send Message</button>
          </form>

          </div>

        </div>

        {/* <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Contact Us</h2>
          <form className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-md">
            <input type="text" placeholder="Your Name" className="w-full p-3 border rounded-lg mb-4 focus:outline-blue-500" />
            <input type="email" placeholder="Your Email" className="w-full p-3 border rounded-lg mb-4 focus:outline-blue-500" />
            <textarea placeholder="Your Message" className="w-full p-3 border rounded-lg mb-4 h-32 focus:outline-blue-500"></textarea>
            <button className="w-full bg-blue-600 text-white p-3 rounded-lg font-semibold hover:bg-blue-700 transition">Send Message</button>
          </form>
        </div> */}

      </section>
    );
  };
  
  export default Contact;
  